import { LoadingButton } from '@mui/lab'
import { Alert, Box, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material'
import React from 'react'
import CustomButton from './button'
import UpdateIcon from '@mui/icons-material/Update';
import CloseIcon from '@mui/icons-material/Close'
import { padding } from '../../theme';

type ModalProps = ({
  title: string,
  savingFailedMessage: string,
  savingOngoingMessage?: string
  savingSuccessMessage: React.ReactNode,
  saveButtonText: string,
  children?: React.ReactNode | null,
  open: boolean,
  fullScreen?: boolean,
  closeModal: Function,
  onSave: React.MouseEventHandler<HTMLButtonElement>,
  savingDisabled?: boolean,
  saving?: boolean,
  savingFailed: boolean,
  savingOngoing: boolean,
  savingSuccessful: boolean,
  setSavingFailed: Function
})

export const SaveModal = ({
  title,
  savingFailedMessage,
  savingSuccessMessage,
  savingOngoingMessage = 'Task is currently processing...',
  saveButtonText,
  children,
  open,
  closeModal,
  fullScreen,
  onSave,
  savingDisabled=false,
  saving,
  savingFailed,
  savingOngoing,
  savingSuccessful,
  setSavingFailed
}: ModalProps) => {

  return (
    <Dialog open={open} fullScreen={fullScreen}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <SavingOngoingAlert savingOngoingMessage={savingOngoingMessage} show={savingOngoing} />
        <SavingFailedAlert savingFailedMessage={savingFailedMessage} show={savingFailed} />
        <SavingSuccessAlert savingSuccessMessage={savingSuccessMessage} show={savingSuccessful} />
        {children}
      </DialogContent>

      <DialogActions>
        <CustomButton outlined onClick={(event: any) => {
          setSavingFailed(null)
          closeModal()
        }}>Close</CustomButton>
        <LoadingButton
          disabled={savingDisabled}
          loading={saving}
          onClick={(event) => {
            onSave(event)
            setSavingFailed(null)
          }}
          loadingPosition="start"
          startIcon={<UpdateIcon />}
          variant="contained">
          {saveButtonText}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}

export function SavingFailedAlert({ show, savingFailedMessage }: {show: boolean, savingFailedMessage: string}) {
  return (
    <Collapse in={show}>
      <Alert
        severity="error"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
          >
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        {savingFailedMessage}
      </Alert>
    </Collapse>
  )
}

export function SavingOngoingAlert({ show, savingOngoingMessage }: {show: boolean, savingOngoingMessage: string}) {
  return (
    <Collapse in={show}>
      <Alert
        severity="info"
        sx={{ mb: 2 }}
      >
        {savingOngoingMessage}
      </Alert>
    </Collapse>
  )
}

export function SavingSuccessAlert({ show, savingSuccessMessage }: { show: boolean; savingSuccessMessage: React.ReactNode }) {
  return (
    <Collapse in={show}>
      <Alert
        severity="success"
        action={
          <IconButton
            aria-label="close"
            color="inherit"
            size="small"
          >
            <CloseIcon fontSize="inherit" />
          </IconButton>
        }
        sx={{ mb: 2 }}
      >
        {savingSuccessMessage}
      </Alert>
    </Collapse>
  )
}

export const Subheader = ({ title, noPadding = false } : { title: string, noPadding: boolean }) => {
  return (
    <Box style={{
      paddingTop: noPadding ? 'auto' : padding * 3
    }}>
      <DialogContentText>{title}</DialogContentText>
    </Box>
  )
}
